import React from "react";
import {Tag} from "antd";
import "./delivery-info-page.css";
import classnames from "classnames";

export const SectionInfo = ({title, value, className, contactsInfo = []}) => {
    return (
        <span className={classnames("delivery-info-section-info", className)}>
            <span style={{fontWeight: "bold"}}>{title}</span>
            {value}
            {contactsInfo?.length > 0 && <span>|</span>}
            {contactsInfo?.map(({name, phone}, index) => {
                return (
                    <span key={index}>
                        {name}&nbsp;
                        <a key="tel" href={`tel:${phone}`}>
                            {phone}
                        </a>
                    </span>
                );
            })}
        </span>
    );
};

export const ContactInfoTag = ({contactsInfo = []}) => {
    return contactsInfo?.map(({name, phone}, index) => {
        return (
            <a key="tel" href={`tel:${phone}`}>
                <Tag
                    key={index}
                    style={{
                        borderRadius: 9999,
                        paddingInline: 12,
                        color: "white",
                        background: "blue",
                        borderColor: "blue"
                    }}>
                    {name} {phone}
                </Tag>
            </a>
        );
    });
};
